<template>
  <v-tooltip bottom dark>
    <template v-slot:activator="{ on }">
      <v-btn class="ml-2" icon outlined color="primary" dark :loading="loading" v-on="on" @click="generateReport()">
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-btn>
    </template>
    <span>Generuj raport</span>
  </v-tooltip>
</template>

<script>
import ReportApi from '@/api/reportApi';

export default {
  props: {
    assignedCourse: {
      type: Object,
      required: true
    },
    group: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      loading: false
    };
  },
  methods: {
    async generateReport() {
      this.loading = true;
      try {
        const api = new ReportApi(this.token);
        const response = await api.getCourseResultReport({
          courseIds: [this.assignedCourse.courseId],
          groupIds: [this.group.id]
        });
        api.downloadFile(response, 'raport.xlsx');
      } catch (e) {
        console.error(e);
        // TODO: handle
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
